import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * Resets the window scroll position to the top whenever the route's pathname
 * changes, so navigating to a new page (child detail, contract, etc.) always
 * starts at the top instead of inheriting the previous page's scroll offset.
 *
 * Keyed on `pathname` only — intentionally NOT `search`/`hash` — so in-page
 * query-param changes (billing tabs, list filters, the reconciliation
 * `?debtor=` detail) keep their current scroll position.
 *
 * The app scrolls on the document/window (no dedicated overflow container in
 * the shell), so `window.scrollTo` is the correct target. Renders nothing.
 */
export function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
